// extracted by mini-css-extract-plugin
export default {"content":"indes_content__WOPlP","signButton":"indes_signButton__2p0Fr"};